// extracted by mini-css-extract-plugin
export default {"moreInfo":"ButtonSeeProject_moreInfo__fD+5N","open":"ButtonSeeProject_open__iwFec","text":"ButtonSeeProject_text__hY+zg","svg":"ButtonSeeProject_svg__rK8aB"};